// TODO - Type 'any' needs to be fixed.
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { changeSelectedMenuItemId } from "../../../export/attendance-reports";
import PageLayout from "../../design/wilya-page-layout";
import { closeNavigationDrawer } from "../../features/navigation-drawer/navigation-drawer-slice";
import NavDrawer from "../drawer/ui";
import ManageTimeOffBalancesReport from "./manage-time-off-balances-report";

const TimeOffBalancesReport = () => {
	const dispatch = useDispatch();
	useEffect(() => {
	dispatch(changeSelectedMenuItemId(22));
    dispatch(closeNavigationDrawer());
	}, [dispatch]);
	return (
		<Box sx={{ display: "flex", backgroundColor: "#F5F5F5" }}>
			<CssBaseline />
			<NavDrawer
				keepSettingOpen={false}
			/>
			<Box sx={{ flexGrow: 1, overflow: "auto" }}>
				<PageLayout>
					<ManageTimeOffBalancesReport />
				</PageLayout>
			</Box>
		</Box>
	);
};

export default TimeOffBalancesReport;
